import {StepWait} from '../../types/Steps'

export const initialWaitConfig: Pick<StepWait, 'config' | 'haveWarnings'> = {
  haveWarnings: true,
  config: {
    value: null,
  },
}
